import { Injectable, Signal, signal } from '@angular/core';
import { BonusabfrageQuery } from '../types/bonusabfrage-query';

@Injectable()
export class BonusabfrageQueryService {
  readonly bonusQuery = signal<Signal<BonusabfrageQuery | undefined>>(signal(undefined));

  setBonusQuery(bonusQuery: Signal<BonusabfrageQuery | undefined>) {
    this.bonusQuery.set(bonusQuery);
  }
}
